export * from '@wix/headless-multilingual/react';